import React from 'react';
import IOwner from 'src/models/IOwner';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerJointTenant from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenant';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import AddressUtil from 'src/util/Address';

interface IOwnerDisplay {
    owner: IOwner;
    displayStyle: 'Flat' | 'Card';
}

const IndividualOwnerFlat = (owner: OwnerIndividual) => (
    <div className="change-owner-detail-card">
        <div className="change-owner-detail-card-name"> {owner.firstName + ' ' + owner.lastName} </div>
        <div className="change-owner-detail-card-address"> {owner.address?.addressLine1} </div>
        <div className="change-owner-detail-card-address">
            {AddressUtil.concatWithCommas(owner.address?.city, owner.address?.state?.name, owner.address?.zipCode)}
        </div>
    </div>
);

const TrustOwnerFlat = (owner: OwnerTrust) => (
    <div className="change-owner-detail-card">
        <div className="change-owner-detail-card-name"> {owner.trustName} </div>
        <div className="change-owner-detail-card-address"> {owner.address?.addressLine1} </div>
        <div className="change-owner-detail-card-address">
            {AddressUtil.concatWithCommas(owner.address?.city, owner.address?.state?.name, owner.address?.zipCode)}
        </div>
    </div>
);

const BusinessOwnerFlat = (owner: OwnerBusiness) => (
    <div className="change-owner-detail-card">
        <div className="change-owner-detail-card-name"> {owner.name} </div>
        <div className="change-owner-detail-card-address"> {owner.address?.addressLine1} </div>
        <div className="change-owner-detail-card-address">
            {AddressUtil.concatWithCommas(owner.address?.city, owner.address?.state?.name, owner.address?.zipCode)}
        </div>
    </div>
);

const RalOwnerFlat = (owner: OwnerRAL) => (
    <div className="change-owner-detail-card">
        <div className="change-owner-detail-card-name"> {owner.surfaceOwnerAgentFirstName + ' ' + owner.surfaceOwnerAgentLastName} </div>
        <div className="change-owner-detail-card-address"> {owner.address?.addressLine1} </div>
        <div className="change-owner-detail-card-address">
            {AddressUtil.concatWithCommas(owner.address?.city, owner.address?.state?.name, owner.address?.zipCode)}
        </div>
    </div>
);

const StateOwnerFlat = (owner: OwnerStateLand) => (
    <div className="change-owner-detail-card">
        <div className="change-owner-detail-card-name"> {owner.agencyName} </div>
        <div className="change-owner-detail-card-address"> {owner.address?.addressLine1} </div>
        <div className="change-owner-detail-card-address">
            {AddressUtil.concatWithCommas(owner.address?.city, owner.address?.state?.name, owner.address?.zipCode)}
        </div>
    </div>
);

const BolmOwnerFlat = (owner: OwnerBOLM) => {
    console.log(owner);
    return (
        <div className="change-owner-detail-card">
            <div className="change-owner-detail-card-name"> {owner.regionalOffice} </div>
            <div className="change-owner-detail-card-address"> {owner.address?.addressLine1} </div>
            <div className="change-owner-detail-card-address">
                {AddressUtil.concatWithCommas(owner.address?.city, owner.address?.state?.name, owner.address?.zipCode)}
            </div>
        </div>
    );
};

const JointTenantOwnerFlat = (owner: OwnerJointTenant) => (
    <div className="change-owner-detail-card">
        <div className="change-owner-detail-card-name"> {owner.name} </div>
        <div className="change-owner-detail-card-address"> {owner.addressLine1} </div>
        <div className="change-owner-detail-card-address">
            {AddressUtil.concatWithCommas(owner.city, owner.state, owner.zipCode)}
        </div>
    </div>
);

const OwnerDisplay: React.FC<IOwnerDisplay> = (props) => {
    if (!props.owner) {
        return <div>Loading</div>;
    }

    if (props.displayStyle === 'Card') {
        return <div>Not Yet Implemented</div>;
    }

    if (props.displayStyle === 'Flat') {
        switch (props.owner.ownerType) {
            case 'Individual':
                return IndividualOwnerFlat(props.owner as OwnerIndividual);
            case 'Trust':
                return TrustOwnerFlat(props.owner as OwnerTrust);
            case 'Business':
                return BusinessOwnerFlat(props.owner as OwnerBusiness);
            case 'Gov-RAL':
                return RalOwnerFlat(props.owner as OwnerRAL);
            case 'Gov-STATE':
                return StateOwnerFlat(props.owner as OwnerStateLand);
            case 'Gov-BLM':
                return BolmOwnerFlat(props.owner as OwnerBOLM);
            case 'JointTenant':
                return JointTenantOwnerFlat(props.owner as OwnerJointTenant);
            default:
                return <div>Error: Owner Type Not Found</div>;
        }
    }

    return <div>[Unexpected Error]</div>;
};

export default OwnerDisplay;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/OwnerDisplay.tsx